import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const CalendarIcon = props => {
    // tslint:disable
    return (
        <SvgRoot {...props}>
            <g fill="none" stroke={props.nativeColor}>
                <line x1="9" y1="4" x2="15" y2="4"/>
                <line x1="2.5" y1="10" x2="21" y2="10"/>
                <circle cx="7.2" cy="7" r="1.3"/>
                <circle cx="16.6" cy="7" r="1.3"/>
                <line x1="7.2" y1="2.8" x2="7.2" y2="5.7"/>
                <line x1="16.6" y1="2.8" x2="16.6" y2="5.7"/>
                <path d="M18.3,4h1.5c0.8,0,1.5,0.7,1.5,1.5v13.8c0,0.8-0.7,1.5-1.5,1.5H4c-0.8,0-1.5-0.7-1.5-1.5V5.5C2.5,4.7,3.2,4,4,4h1.5"/>
            </g>
        </SvgRoot>
    );
}

export default CalendarIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/CalendarIcon.tsx